/** Function to copy only the text. */
export const copyText = async (dom, setSnackbar, dispatch) => {
    try {
        const element = dom.current;
        const input = element.textContent;

        /** Convert the dom into a blob format, transfer it to the clipboard, and mark it as copied. */
        const blob = new Blob([input], { type: 'text/plain' });
        const clipboarditem = new ClipboardItem({ 'text/plain': blob });

        await navigator.clipboard.write([clipboarditem]);
        dispatch(setSnackbar({ open: true, message: 'Copy completed successfully.', severity: 'success' }));
    } catch (err) {
        dispatch(setSnackbar({ open: true, message: 'Copy failed.', severity: 'error' }));
    }
};

// export const copyTable = async (dom, setLoading, setSnackbar, dispatch) => {
//     setLoading(true);

//     try {
//         const element = dom.current;
//         if (!element) throw new Error('DOM element not found');

//         const clonedElement = element.cloneNode(true);

//         const originalNodes = [element, ...element.querySelectorAll('*')];
//         const clonedNodes = [clonedElement, ...clonedElement.querySelectorAll('*')];

//         const pxToPt = (px) => px;

//         const importantProps = [
//             'color',
//             'font-size',
//             'font-family',
//             'font-weight',
//             'font-style',
//             'text-align',
//             'text-decoration',
//             'text-transform',
//             'line-height',
//             'letter-spacing',
//             'word-spacing',
//             'white-space',
//             'background-color',
//             'background-image',
//             'width',
//             'height',
//             'min-width',
//             'max-width',
//             'padding',
//             'padding-top',
//             'padding-right',
//             'padding-bottom',
//             'padding-left',
//             'margin',
//             'margin-top',
//             'margin-right',
//             'margin-bottom',
//             'margin-left',
//             'border',
//             'border-top',
//             'border-right',
//             'border-bottom',
//             'border-left',
//             'border-radius',
//             'border-collapse',
//             'border-spacing',
//             'display',
//             'flex-direction',
//             'justify-content',
//             'align-items',
//             'flex-wrap',
//             'gap',
//             'vertical-align',
//             'overflow',
//             'opacity',
//             'visibility',
//             'box-sizing',
//             'table-layout',
//         ];

//         originalNodes.forEach((originalNode, index) => {
//             const clonedNode = clonedNodes[index];
//             if (!clonedNode) return;

//             const computedStyle = window.getComputedStyle(originalNode);

//             importantProps.forEach((prop) => {
//                 let value = computedStyle.getPropertyValue(prop);

//                 if (prop === 'font-size') {
//                     const pxValue = parseFloat(value);
//                     if (!isNaN(pxValue)) {
//                         const ptValue = pxToPt(pxValue);
//                         clonedNode.style.setProperty('font-size', `${ptValue}pt`, 'important');
//                         clonedNode.style.setProperty('mso-font-size', `${ptValue}pt`);
//                         return; // px 덮어쓰기 방지
//                     }
//                 }

//                 if (value) {
//                     clonedNode.style.setProperty(prop, value, 'important');
//                 }
//             });
//         });

//         const tempContainer = document.createElement('div');
//         tempContainer.style.cssText = `
//             font-size: 10pt !important;
//             font-family: 'Malgun Gothic', Arial, sans-serif !important;
//             line-height: normal !important;
//             margin: 0 !important;
//             padding: 0 !important;
//         `;
//         tempContainer.appendChild(clonedElement);

//         const htmlToCopy = tempContainer.innerHTML;

//         const blob = new Blob([htmlToCopy], { type: 'text/html' });
//         const clipboardItem = new ClipboardItem({ 'text/html': blob });

//         await navigator.clipboard.write([clipboardItem]);

//         dispatch(setSnackbar({ open: true, message: 'Copy completed successfully.', severity: 'success' }));
//     } catch (err) {
//         console.error(err);
//         dispatch(setSnackbar({ open: true, message: 'Copy failed.', severity: 'error' }));
//     } finally {
//         setLoading(false);
//     }
// };

const FONT_STACK = "'Malgun Gothic', 'Apple SD Gothic Neo', Arial, sans-serif";

/** 'rgb(r, g, b)' / 'rgba(r, g, b, a)' → '#rrggbb' (Outlook/Word 엔진 호환용) */
const rgbToHex = (rgbStr) => {
    const match = rgbStr.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (!match) return null;
    const [, r, g, b] = match;
    return (
        '#' +
        [r, g, b]
            .map((v) => parseInt(v, 10).toString(16).padStart(2, '0'))
            .join('')
    );
};

const pxToPt = (px) => +(px * 0.75).toFixed(1);
const appendRawStyle = (el, css) => {
    const prev = el.getAttribute('style') || '';
    el.setAttribute('style', prev + (prev.endsWith(';') || !prev ? '' : ';') + css);
};

export const copyTable = async (dom, setLoading, setSnackbar, dispatch) => {
    setLoading(true);

    try {
        const element = dom.current;
        if (!element) throw new Error('DOM element not found');

        const clonedElement = element.cloneNode(true);

        const originalNodes = [element, ...element.querySelectorAll('*')];
        const clonedNodes = [clonedElement, ...clonedElement.querySelectorAll('*')];

        const cloneOf = new Map();
        originalNodes.forEach((node, index) => cloneOf.set(node, clonedNodes[index]));

        const colorHexOf = new Map();

        const pendingRawStyles = [];
        const queueRawStyle = (el, css) => pendingRawStyles.push([el, css]);

        originalNodes.forEach((originalNode, index) => {
            let clonedNode = clonedNodes[index];
            if (!clonedNode) return;

            const tag = originalNode.tagName;
            const computedStyle = window.getComputedStyle(originalNode);

            // ── 0. <th> → <td> 치환 ──────────────────────────────────
            if (tag === 'TH') {
                const td = document.createElement('td');
                Array.from(clonedNode.attributes).forEach((attr) => td.setAttribute(attr.name, attr.value));
                while (clonedNode.firstChild) td.appendChild(clonedNode.firstChild);
                clonedNode.replaceWith(td);
                clonedNode = td;
                clonedNodes[index] = td;
                cloneOf.set(originalNode, td);
            }

            // ── 1. colSpan / rowSpan 명시적 재지정 ───────────────────
            if (tag === 'TD' || tag === 'TH') {
                const colSpan = originalNode.colSpan;
                const rowSpan = originalNode.rowSpan;
                if (colSpan > 1) clonedNode.setAttribute('colspan', colSpan);
                if (rowSpan > 1) clonedNode.setAttribute('rowspan', rowSpan);
            }

            // ── 2. <br> 삽입 (class 제거 전에 먼저) ──────────────────
            {
                const children = Array.from(clonedNode.childNodes);
                children.forEach((child, i) => {
                    if (child.nodeType === Node.ELEMENT_NODE && child.tagName === 'SPAN' && i < children.length - 1) {
                        child.after(document.createElement('br'));
                    }
                });
            }

            // ── 3. 필요한 스타일만 추출 ───────────────────────────────
            const inlineStyles = {};
            // CSSOM이 버리는 mso-* 선언은 별도로 모은다
            const rawStyles = [];

            // 폰트
            inlineStyles['font-family'] = FONT_STACK;

            // 폰트 사이즈: 10pt로 고정
            inlineStyles['font-size'] = '10pt';

            if (tag === 'TD' || tag === 'TH' || tag === 'SPAN') {
                const lineHeight = parseFloat(computedStyle.getPropertyValue('line-height'));
                inlineStyles['line-height'] = !isNaN(lineHeight) ? `${(lineHeight * 0.9).toFixed(2)}pt` : 'normal';
                rawStyles.push('mso-line-height-rule:exactly');
            }

            // 폰트 굵기
            const fontWeight = computedStyle.getPropertyValue('font-weight');
            if (fontWeight) inlineStyles['font-weight'] = fontWeight;

            // 글자 색상 (Outlook/Word 엔진은 rgb() 함수 표기를 못 읽는 경우가 많아 hex로 변환)
            // hex는 CSSOM을 거치면 rgb() 표기로 되돌려지므로 <font color>용으로 따로 보관한다.
            const color = computedStyle.getPropertyValue('color');
            if (color && color !== 'rgba(0, 0, 0, 0)') {
                const colorHex = rgbToHex(color);
                inlineStyles['color'] = colorHex || color;
                if (colorHex && /^#[0-9a-f]{6}$/i.test(colorHex)) colorHexOf.set(clonedNode, colorHex);
            }

            // 셀 배경색 (투명 제외, 동일하게 hex 변환)
            const bgColor = computedStyle.getPropertyValue('background-color');
            if (bgColor && bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent') {
                inlineStyles['background-color'] = rgbToHex(bgColor) || bgColor;
            }

            // 텍스트 정렬
            const textAlign = computedStyle.getPropertyValue('text-align');
            if (textAlign) inlineStyles['text-align'] = textAlign;

            // 세로 정렬
            const verticalAlign = computedStyle.getPropertyValue('vertical-align');
            if (verticalAlign) inlineStyles['vertical-align'] = verticalAlign;

            // Outlook(Word 엔진)이 CSS text-align/vertical-align을 무시하는 경우가 있어
            // 레거시 HTML4 속성으로도 동일한 값을 병행 지정
            if (tag === 'TD' || tag === 'TH') {
                if (textAlign) clonedNode.setAttribute('align', textAlign);
                if (verticalAlign) clonedNode.setAttribute('valign', verticalAlign);
                if (inlineStyles['background-color']) {
                    clonedNode.setAttribute('bgcolor', inlineStyles['background-color']);
                }
            }

            // span 줄바꿈: 줄 구분은 인접 <br> 삽입(2번)만으로 보장한다.
            // display:block까지 함께 유지하면 이를 실제로 지원하는 렌더러(WebKit 계열 등)에서
            // <br> + block 줄바꿈이 겹쳐 줄바꿈이 두 번 일어나므로, span은 inline으로 강제한다.
            if (tag === 'SPAN') {
                inlineStyles['display'] = 'inline';
                // 텍스트 안에 남아있는 개행 문자도 <br>과 겹치지 않도록 제거
                Array.from(clonedNode.childNodes).forEach((child) => {
                    if (child.nodeType === Node.TEXT_NODE) {
                        child.nodeValue = child.nodeValue.replace(/\r\n|\n|\r/g, ' ');
                    }
                });
            }

            // 줄바꿈: 원본이 실제로 쓰던 white-space를 그대로 보존
            // (여기서 pre-wrap을 강제하면 <br> 삽입과 겹쳐 셀 내부에 남아있는 \n까지
            //  줄바꿈으로 렌더링되어 개행이 중복됨)
            const whiteSpace = computedStyle.getPropertyValue('white-space');
            if (whiteSpace) inlineStyles['white-space'] = whiteSpace;

            // ── 4. class 제거 후 스타일 재지정 ───────────────────────
            clonedNode.removeAttribute('style');
            clonedNode.removeAttribute('class');
            Object.entries(inlineStyles).forEach(([prop, value]) => {
                clonedNode.style.setProperty(prop, value);
            });
            if (rawStyles.length) queueRawStyle(clonedNode, rawStyles.join(';'));
        });

        originalNodes.forEach((originalNode) => {
            const tag = originalNode.tagName;
            if (tag !== 'TD' && tag !== 'TH') return;

            const clonedNode = cloneOf.get(originalNode);
            if (!clonedNode) return;

            const color = clonedNode.style.getPropertyValue('color');
            if (!color) return;

            const colorHex = colorHexOf.get(clonedNode);

            Array.from(clonedNode.childNodes).forEach((child) => {
                if (child.nodeType !== Node.TEXT_NODE || !child.nodeValue.trim()) return;
                const font = document.createElement('font');
                if (colorHex) font.setAttribute('color', colorHex);
                font.style.setProperty('color', colorHex || color);
                child.replaceWith(font);
                font.appendChild(child);
            });
        });

        // ── 5. table 구조 스타일 직접 지정 ───────────────────────────
        const tables = clonedElement.querySelectorAll('table');
        tables.forEach((table) => {
            table.setAttribute('border', '1');
            table.setAttribute('cellspacing', '0');
            table.setAttribute('role', 'presentation');
            table.style.setProperty('border-collapse', 'collapse');
            table.style.setProperty('font-family', FONT_STACK);
            table.style.setProperty('font-size', '10pt');
            queueRawStyle(table, 'mso-table-lspace:0pt;mso-table-rspace:0pt;mso-table-layout-alt:fixed');
        });

        originalNodes.forEach((originalNode) => {
            if (originalNode.tagName !== 'TABLE') return;
            const clonedTable = cloneOf.get(originalNode);
            if (!clonedTable) return;

            // colspan이 없는 행 중 셀 수가 가장 많은 행을 열 너비 기준 행으로 삼는다
            let baseRow = null;
            Array.from(originalNode.rows).forEach((row) => {
                const cells = Array.from(row.cells);
                if (!cells.length || cells.some((cell) => cell.colSpan > 1)) return;
                if (!baseRow || cells.length > baseRow.cells.length) baseRow = row;
            });
            if (!baseRow) return;

            const baseCells = Array.from(baseRow.cells);

            const widthsPx = baseCells.map((cell) => Math.round(cell.getBoundingClientRect().width));
            const totalPx = widthsPx.reduce((acc, v) => acc + v, 0);
            if (!totalPx) return;

            const colgroup = document.createElement('colgroup');
            widthsPx.forEach((px) => {
                const col = document.createElement('col');
                col.style.setProperty('width', `${pxToPt(px)}pt`);
                col.setAttribute('width', `${px}`); // 레거시 픽셀 속성 병행
                colgroup.appendChild(col);
            });
            clonedTable.insertBefore(colgroup, clonedTable.firstChild);

            // Word는 col보다 셀의 width 속성을 우선 신뢰하는 경우가 있어 기준 행에도 병행 지정
            baseCells.forEach((cell, cellIdx) => {
                const clonedCell = cloneOf.get(cell);
                if (!clonedCell) return;
                clonedCell.style.setProperty('width', `${pxToPt(widthsPx[cellIdx])}pt`);
                clonedCell.setAttribute('width', `${widthsPx[cellIdx]}`);
            });

            clonedTable.style.setProperty('width', `${pxToPt(totalPx)}pt`);
            clonedTable.setAttribute('width', `${totalPx}`);
            clonedTable.style.setProperty('table-layout', 'fixed');
        });

        pendingRawStyles.forEach(([el, css]) => appendRawStyle(el, css));

        // ── 6. Outlook / Gmail 호환 래퍼 ─────────────────────────────
        const wrappedHtml = `
            <html xmlns:o="urn:schemas-microsoft-com:office:office"
                  xmlns:w="urn:schemas-microsoft-com:office:word"
                  xmlns="http://www.w3.org/TR/REC-html40">
            <head>
                <meta charset="utf-8">
                <!--[if gte mso 9]>
                <xml>
                    <w:WordDocument>
                        <w:View>Normal</w:View>
                        <w:Zoom>0</w:Zoom>
                        <w:TrackMoves/>
                        <w:TrackFormatting/>
                        <w:DoNotExpandShiftReturn/>
                    </w:WordDocument>
                </xml>
                <![endif]-->
                <style>
                    table {
                        border-collapse: collapse;
                        font-family: ${FONT_STACK};
                        font-size: 10pt;
                        mso-table-lspace: 0pt;
                        mso-table-rspace: 0pt;
                    }
                    td, th {
                        border: 1px solid black;
                        padding: 3px;
                        white-space: pre-wrap;
                        word-break: break-word;
                        font-family: ${FONT_STACK};
                        line-height: normal;
                    }
                </style>
            </head>
            <body>
                ${clonedElement.innerHTML}
            </body>
            </html>
        `;

        const blob = new Blob([wrappedHtml], { type: 'text/html' });
        const clipboardItem = new ClipboardItem({ 'text/html': blob });
        await navigator.clipboard.write([clipboardItem]);

        dispatch(setSnackbar({ open: true, message: 'Copy completed successfully.', severity: 'success' }));
    } catch (err) {
        console.error(err);
        dispatch(setSnackbar({ open: true, message: 'Copy failed.', severity: 'error' }));
    } finally {
        setLoading(false);
    }
};
